import { initializeApp } from "firebase/app";
import { getAuth, browserLocalPersistence, setPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDgvPONMO3rKAXa1LlKkvMf_5sX3CCJzCA",
  authDomain: "qkard-299b7.firebaseapp.com",
  projectId: "qkard-299b7",
  storageBucket: "qkard-299b7.firebasestorage.app",
  messagingSenderId: "947209155648",
  appId: "1:947209155648:web:c0c4efb13e9a034ffc1ba5"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence);
export default app;
